module.exports = __webpack_public_path__ + "static/media/close.3b0ffcd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/unmappedAccounts/close.svg
// module id = 1989
// module chunks = 0